<script>
	export let data = {};
</script>

<dl class="UITable">
	<dt>{@html data.label.split("\n").join("<br>")}</dt>
	<dd>{@html data.html.split("\n").join("<br>")}</dd>
</dl>

<style global>
	.UITable {
		color: #524e4e;
		border: 1px solid #ccc;
		font-size: 1em;
		display: flex;
		align-items: stretch;
		max-width: 720px;
		margin: 1em auto;
	}
	.UITable + .UITable {
		margin-top: -1em;
		border-top: none;
	}

	.UITable dt {
		padding: 1em;
		line-height: 1.75;
		width: 20%;
		background: #efefef;
	}

	/* :global(.pc) .UITable dt span {
		display: block;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
	} */
	.UITable dd {
		padding: 1em;
		line-height: 1.75;
		text-align: left;
		border-left: 1px solid #ccc;
		width: 80%;
	}

	:global(.s) .UITable {
		display: block;
	}
	:global(.s) .UITable dt {
		background: none;
		width: 100%;
		text-align: left;
		padding-bottom: 0;
		font-weight: bold;
		font-size: 0.9em;
	}

	:global(.s) .UITable dd {
		border-left: none;
		width: 100%;
		padding: 0.25em 1em 1em 2em;
	}
</style>
